export const MelCategoryCustomerExcelHeader = [
  // {
  //   header: 'CATEGORY CODE',
  //   key: 'CATEGORY CODE'
  // },
  // {
  //   header: 'CATEGORY NAME',
  //   key: 'CATEGORY NAME'
  // },
  {
    header: "CREATED BY",
    key: "CREATED BY",
  },
  {
    header: "CREATED DATE",
    key: "CREATED DATE",
  },
];

export const MelCategoryCustomerExcelName = "Mel Category Customer List";
